// Page-level amount privacy for My Pay. Persisted so the choice survives
// navigation/refresh (same localStorage approach as the theme's `kazi-theme`).
// Presentation only — authorization always stays server-side; the stored value
// is a boolean preference, never data.
import { useCallback, useState } from 'react';

const KEY = 'kazi-mypay-amounts';

export function useAmountPrivacy(): { revealed: boolean; toggle: () => void } {
  const [revealed, setRevealed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(KEY) === 'shown';
    } catch {
      return false; // default hidden (e.g. storage blocked)
    }
  });

  const toggle = useCallback(() => {
    setRevealed((r) => {
      const next = !r;
      try {
        localStorage.setItem(KEY, next ? 'shown' : 'hidden');
      } catch {
        /* preference just won't persist */
      }
      return next;
    });
  }, []);

  return { revealed, toggle };
}
